/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MovementOnFundsReportFundOperationDtoEmployee
 */
export interface MovementOnFundsReportFundOperationDtoEmployee {
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportFundOperationDtoEmployee
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportFundOperationDtoEmployee
   */
  name: string;
}

export function MovementOnFundsReportFundOperationDtoEmployeeFromJSON(
  json: any
): MovementOnFundsReportFundOperationDtoEmployee {
  return MovementOnFundsReportFundOperationDtoEmployeeFromJSONTyped(json, false);
}

export function MovementOnFundsReportFundOperationDtoEmployeeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MovementOnFundsReportFundOperationDtoEmployee {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    name: json["name"],
  };
}

export function MovementOnFundsReportFundOperationDtoEmployeeToJSON(
  value?: MovementOnFundsReportFundOperationDtoEmployee | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
